export default "/fonts/vendor/mdui/dist/icons/material-icons/MaterialIcons-Regular.woff2?cff684e59ffb052d72cb8d5e49471553";